import { addTradeArea } from "../../../redux/slices/mapSlice";
import {
  CalculatePixelDistance,
  GetRandomBrightColor,
  NearestDistance,
} from "../../../utils/helper";
import { CustomLogoClass } from "./CustomLogo";
import * as turf from "@turf/turf";

export class CustomPOIClass {
  static POIImageWidth = "80px";
  static GetClusterHeaderIcons = () => {
    const headerIconsDiv = document.createElement("span");
    headerIconsDiv.className = "cluster-header-icons";

    return headerIconsDiv;
  };

  static RemoveElementFromObjectArray = ({
    keyToRemove,
    valueToRemove,
    setPOICategoryList,
  }) => {
    setPOICategoryList((prevState) => {
      const newState = { ...prevState.selectedPOIRetailerNameList };
      if (newState[keyToRemove]) {
        newState[keyToRemove] = newState[keyToRemove].filter(
          (value) => value !== valueToRemove
        );
      }
      return {
        ...prevState,
        selectedPOIRetailerNameList: newState,
        triggerPoiCheck: prevState.triggerPoiCheck,
      };
    });
  };

  static GetPoiImageUrl = (retailerId) =>
    `${process.env.REACT_APP_ASSETS_URL}poi/svg/${retailerId}.svg`;

  static RemovePoiImage = ({
    id,
    map,
    mapDraw,
    setPOICategoryList,
    setUndoHistory,
    markerRef,
  }) => {
    if (map) {
      const changedMarkers = markerRef.current.filter((marker) => {
        if (marker.id === id) {
          const markerId = marker.id.split("^");
          const retailerId = markerId[3];
          const markerElement = marker.marker.getElement();
          const image = markerElement.querySelector("img");
          marker.marker.remove();
          const vertexPoint = map.getLayer(marker.id + "-end-point");
          if (vertexPoint) {
            map.removeLayer(marker.id + "-end-point");
            map.removeSource(marker.id + "-end-point");
          }
          mapDraw = mapDraw.current || mapDraw;
          mapDraw.delete(image.dataset.lineConnected);
          this.RemoveElementFromObjectArray({
            keyToRemove: retailerId,
            valueToRemove: image.id,
            setPOICategoryList,
          });
          setUndoHistory((previousState) =>
            previousState.filter((data) => data.id !== marker.id)
          );
          return false;
        } else {
          return true;
        }
      });
      markerRef.current = changedMarkers;
    }
  };

  static AddToCluster = ({
    mapboxgl,
    map,
    mapDraw,
    clusterMarkerId,
    retailerDetails,
    poiRetailerId,
    lastClickButton,
    logoDefaultStyle,
    defaultLogoValue,
    setSelectedLogo,
    setMapToolBarOptionFlags,
    setResetMap,
    createNewPolygon,
    updateAutoSave,
    resetAllOnceChanged,
    poiSetting,
    currentMode,
    polygonDefaultStyle,
    getCurrentPoiSetting,
    setDrawnFeaturesSupport,
    setUndoHistory,
    setRedoHistory,
    markerRef,
    disableUserActions,
  }) => {
    console.log("adding to cluster...");
    for (const toBeClusteredMarker of markerRef.current) {
      if (clusterMarkerId === toBeClusteredMarker.id) {
        const currentMarkerElement = toBeClusteredMarker.marker.getElement();
        const currentMarkerElementContainer =
          currentMarkerElement.querySelector("div");
        const currentMarkerElementSubElement =
          currentMarkerElementContainer.querySelector("div");

        const subElement = this.GetClusterImageList({
          inputMarkerId: poiRetailerId,
          logoDefaultStyle,
          poiSetting,
          logo: this.GetPoiImageUrl(retailerDetails.retailer_id),
        });
        // CustomLogoClass.AddClusterLogoEventListener({
        //   currenMarker: toBeClusteredMarker.marker,
        //   subElement,
        //   map,
        //   mapDraw,
        //   mapboxgl,
        //   logoDefaultStyle,
        //   lastClickButton,
        //   defaultLogoValue,
        //   poiSetting,
        //   setSelectedLogo,
        //   setMapToolBarOptionFlags,
        //   updateAutoSave,
        //   setResetMap,
        //   createNewPolygon,
        //   resetAllOnceChanged,
        //   currentMode,
        //   polygonDefaultStyle,
        //   getCurrentPoiSetting,
        //   setDrawnFeaturesSupport,
        //   setUndoHistory,
        //   setRedoHistory,
        //   markerRef,
        //   disableUserActions,
        // });
        currentMarkerElementContainer.append(subElement);
        // currentMarkerElementSubElement.style.height = "100px";
        // currentMarkerElementSubElement.style.width = "100px";
        // CustomLogoClass.AddClusterLogoEventListener({
        //   currenMarker: toBeClusteredMarker.marker,
        //   subElement: currentMarkerElementSubElement,
        //   map,
        //   mapDraw,
        //   mapboxgl,
        //   logoDefaultStyle,
        //   lastClickButton,
        //   defaultLogoValue,
        //   poiSetting,
        //   setSelectedLogo,
        //   setMapToolBarOptionFlags,
        //   updateAutoSave,
        //   setResetMap,
        //   createNewPolygon,
        //   resetAllOnceChanged,
        //   currentMode,
        //   polygonDefaultStyle,
        //   getCurrentPoiSetting,
        //   setDrawnFeaturesSupport,
        //   setUndoHistory,
        //   setRedoHistory,
        //   markerRef,
        //   disableUserActions,
        // });
        currentMarkerElement.style.width = "auto";
        currentMarkerElement.style.height = "auto";
        const checkClusterHasClusterControlTag =
          currentMarkerElement.querySelector("#move-cluster-leader-line");
        if (!checkClusterHasClusterControlTag) {
          const headerIconsDiv = this.GetClusterHeaderIcons();
          currentMarkerElement.appendChild(headerIconsDiv);
          const mapClusterInterActionFunction =
            CustomLogoClass.GetLogoInteractionButtons();
          headerIconsDiv.append(mapClusterInterActionFunction.move);
          headerIconsDiv.append(mapClusterInterActionFunction.remove);
          mapClusterInterActionFunction.remove.addEventListener(
            "mousedown",
            function () {
              CustomLogoClass.ClusterOutAllImagesInside({
                marker: toBeClusteredMarker.marker,
                map,
                mapDraw,
                mapboxgl,
                logoDefaultStyle,
                lastClickButton,
                defaultLogoValue,
                poiSetting,
                setSelectedLogo,
                setMapToolBarOptionFlags,
                updateAutoSave,
                setResetMap,
                createNewPolygon,
                resetAllOnceChanged,
                currentMode,
                polygonDefaultStyle,
                getCurrentPoiSetting,
                setDrawnFeaturesSupport,
                setUndoHistory,
                setRedoHistory,
                markerRef,
              });
            }
          );
        }
        currentMarkerElement.dataset.cluster = "true";
        currentMarkerElementContainer.classList.add("logo-grid-container");
        currentMarkerElementContainer.classList.add("scrollbar-lg");
        if (toBeClusteredMarker.idList) {
          toBeClusteredMarker.idList.push(poiRetailerId);
        } else {
          toBeClusteredMarker.idList = [poiRetailerId, toBeClusteredMarker.id];
        }
        let index = markerRef.current.indexOf(toBeClusteredMarker);
        if (index > -1) {
          markerRef.current[index] = toBeClusteredMarker;
        }
        break;
      }
    }
  };

  static CallOuts = ({
    mapboxgl,
    map,
    mapDraw,
    retailerDetails,
    lastClickButton,
    logoDefaultStyle,
    defaultLogoValue,
    poiSetting,
    currentMode,
    polygonDefaultStyle,
    allCallOutMarker,
    markerLocationCalculated,
    setSelectedLogo,
    setMapToolBarOptionFlags,
    setResetMap,
    createNewPolygon,
    updateAutoSave,
    resetAllOnceChanged,
    getCurrentPoiSetting,
    setDrawnFeaturesSupport,
    setUndoHistory,
    setRedoHistory,
    disableUserActions,
    markerRef,
  }) => {
    const position = {
      lat: retailerDetails.latitude,
      lng: retailerDetails.longitude,
    };
    const projectedPosition = map.project(position);

    const poiRetailerId =
      "poiImage^" +
      retailerDetails.longitude +
      "^" +
      retailerDetails.latitude +
      "^" +
      retailerDetails.retailer_id;

    const AddLogosToMap = () => {
      CustomLogoClass.AddLogoToMap({
        mapboxgl,
        map,
        mapDraw,
        coordinates: position,
        logo: this.GetPoiImageUrl(retailerDetails.retailer_id),
        lastClickButton,
        logoDefaultStyle,
        defaultLogoValue,
        setSelectedLogo,
        setMapToolBarOptionFlags,
        setResetMap,
        createNewPolygon,
        updateAutoSave,
        resetAllOnceChanged,
        poiImageId: poiRetailerId,
        currentMode,
        polygonDefaultStyle,
        getCurrentPoiSetting,
        setDrawnFeaturesSupport,
        setUndoHistory,
        setRedoHistory,
        disableUserActions,
        poiWidth: this.POIImageWidth,
        markerRef,
      });
    };

    // if (poiSetting.poiCallOut === "cluster") {
    //   let createNewImage = true;
    //   if (
    //     markerLocationCalculated.current &&
    //     Object.keys(markerLocationCalculated.current).length > 0
    //   ) {
    //     for (const markerLocation of Object.keys(
    //       markerLocationCalculated.current
    //     )) {
    //       const distance = CalculatePixelDistance(
    //         markerLocationCalculated.current[markerLocation],
    //         projectedPosition
    //       );
    //       if (distance <= NearestDistance) {
    //         createNewImage = false;
    //         this.AddToCluster({
    //           mapboxgl,
    //           map,
    //           mapDraw,
    //           clusterMarkerId: markerLocation,
    //           retailerDetails,
    //           poiRetailerId,
    //           lastClickButton,
    //           logoDefaultStyle,
    //           defaultLogoValue,
    //           setSelectedLogo,
    //           setMapToolBarOptionFlags,
    //           setResetMap,
    //           createNewPolygon,
    //           updateAutoSave,
    //           resetAllOnceChanged,
    //           poiSetting,
    //           currentMode,
    //           polygonDefaultStyle,
    //           getCurrentPoiSetting,
    //           setDrawnFeaturesSupport,
    //           setUndoHistory,
    //           setRedoHistory,
    //           markerRef,
    //           disableUserActions,
    //         });
    //         break;
    //       }
    //     }
    //   }
    //   // if (createNewImage) {
    //   //   markerLocationCalculated.current[poiRetailerId] = projectedPosition;
    //   //   AddLogosToMap();
    //   // }
    // } else if (poiSetting.poiCallOut === "callout") {
    //   if (
    //     markerLocationCalculated.current &&
    //     Object.keys(markerLocationCalculated.current).length > 0
    //   ) {
    //     const markerLocation = Object.keys(markerLocationCalculated.current);
    //     this.AddToCluster({
    //       mapboxgl,
    //       map,
    //       mapDraw,
    //       clusterMarkerId: markerLocation[0],
    //       retailerDetails,
    //       poiRetailerId,
    //       lastClickButton,
    //       logoDefaultStyle,
    //       defaultLogoValue,
    //       setSelectedLogo,
    //       setMapToolBarOptionFlags,
    //       setResetMap,
    //       createNewPolygon,
    //       updateAutoSave,
    //       resetAllOnceChanged,
    //       poiSetting,
    //       currentMode,
    //       polygonDefaultStyle,
    //       getCurrentPoiSetting,
    //       setDrawnFeaturesSupport,
    //       setUndoHistory,
    //       setRedoHistory,
    //       markerRef,
    //       disableUserActions,
    //     });
    //   } else {
    //     AddLogosToMap();
    //     markerLocationCalculated.current[poiRetailerId] = projectedPosition;
    //   }
    // } else {
    //   AddLogosToMap();
    // }
  };

  static AddImageToMapFromPoi = ({
    poiList,
    map,
    mapDraw,
    mapboxgl,
    dispatch,
    tradeArea,
    lastClickButton,
    logoDefaultStyle,
    defaultLogoValue,
    currentMode,
    poiSetting,
    markers,
    setPOICategoryList,
    setSelectedLogo,
    setMapToolBarOptionFlags,
    setResetMap,
    createNewPolygon,
    updateAutoSave,
    resetAllOnceChanged,
    polygonDefaultStyle,
    allCallOutMarker,
    markerLocationCalculated,
    getCurrentPoiSetting,
    setDrawnFeaturesSupport,
    setUndoHistory,
    setRedoHistory,
    disableUserActions,
    markerRef,
  }) => {
    setPOICategoryList((previousValue) => {
      const imageLayerToBeAdded = [];
      const retailerLayerColor = {};
      markerLocationCalculated.current = {};
      allCallOutMarker.current = null;

      if (poiSetting.poiCallOut === "cluster") {
        markers.forEach((marker) => {
          if (marker.id.startsWith("poiImage^")) {
            markerLocationCalculated.current[marker.id] = map.project(
              marker.marker.getLngLat()
            );
          }
        });
      } else if (poiSetting.poiCallOut === "callout") {
        for (const marker of markers) {
          if (marker.id.startsWith("poiImage^")) {
            markerLocationCalculated.current[marker.id] = map.project(
              marker.marker.getLngLat()
            );
            allCallOutMarker.current = marker;
            break;
          }
        }
      }
      setSelectedLogo(null);
      poiList.forEach((retailer) => {
        const poiRetailerId =
          "poiImage^" +
          retailer._source.longitude +
          "^" +
          retailer._source.latitude +
          "^" +
          retailer._source.retailer_id;
        let addImageToMap = true;
        if (
          retailer._source.retailer_id in
            previousValue.selectedPOIRetailerNameList &&
          previousValue.selectedPOIRetailerNameList[
            retailer._source.retailer_id
          ].includes(poiRetailerId)
        ) {
          addImageToMap = false;
          if (
            previousValue.selectedAsLayer.includes(
              String(retailer._source.retailer_id)
            )
          ) {
            addImageToMap = true;
            this.RemovePoiImage({
              id: poiRetailerId,
              map,
              mapDraw,
              setPOICategoryList,
              setUndoHistory,
              markerRef,
            });
          }
        } else if (
          retailer._source.retailer_id in
            previousValue.selectedPOIRetailerNameList &&
          !previousValue.selectedPOIRetailerNameList[
            retailer._source.retailer_id
          ].includes(poiRetailerId)
        ) {
          previousValue.selectedPOIRetailerNameList[
            retailer._source.retailer_id
          ].push(poiRetailerId);
        } else {
          previousValue.selectedPOIRetailerNameList[
            retailer._source.retailer_id
          ] = [poiRetailerId];
        }

        if (addImageToMap) {
          if (
            previousValue.selectedAsLayer.includes(
              String(retailer._source.retailer_id)
            )
          ) {
            const checkAlreadyPoiExits = tradeArea.filter(
              (tradeArea) => tradeArea.id === retailer._source.retailer_id
            );
            const poiColor =
              checkAlreadyPoiExits &&
              checkAlreadyPoiExits.length > 0 &&
              checkAlreadyPoiExits[0].poiColor
                ? checkAlreadyPoiExits[0].poiColor
                : retailer._source.retailer_id in retailerLayerColor
                ? retailerLayerColor[retailer._source.retailer_id]
                : GetRandomBrightColor();
            const poiRadius =
              checkAlreadyPoiExits &&
              checkAlreadyPoiExits.length > 0 &&
              checkAlreadyPoiExits[0]
                ? checkAlreadyPoiExits[0].selected
                  ? 10
                  : 0
                : 10;

            retailerLayerColor[retailer._source.retailer_id] = poiColor;
            imageLayerToBeAdded.push({
              type: "Feature",
              id: poiRetailerId,
              geometry: {
                type: "Point",
                coordinates: [
                  parseFloat(retailer._source.longitude),
                  parseFloat(retailer._source.latitude),
                ],
              },
              properties: {
                retailer_id: retailer._source.retailer_id,
                id: poiRetailerId,
                category: retailer._source.category,
                poiName: retailer._source.poi_name,
                longitude: parseFloat(retailer._source.longitude),
                circle_color: poiColor,
                circle_radius: poiRadius,
                latitude: parseFloat(retailer._source.latitude),
              },
            });
            if (
              !checkAlreadyPoiExits ||
              (checkAlreadyPoiExits && checkAlreadyPoiExits.length === 0)
            ) {
              const param = {
                id: retailer._source.retailer_id,
                coordinates: [
                  parseFloat(retailer._source.latitude),
                  parseFloat(retailer._source.longitude),
                ],
                name: retailer._source.poi_name,
                poiColor: poiColor,
              };
              dispatch(
                addTradeArea({
                  type: "poi-trade-area",
                  value: param,
                })
              );
            }
          } else {
            // this.CallOuts({
            //   mapboxgl,
            //   map,
            //   mapDraw,
            //   retailerDetails: retailer._source,
            //   lastClickButton,
            //   logoDefaultStyle,
            //   defaultLogoValue,
            //   poiSetting,
            //   currentMode,
            //   polygonDefaultStyle,
            //   allCallOutMarker,
            //   markerLocationCalculated,
            //   setSelectedLogo,
            //   setMapToolBarOptionFlags,
            //   setResetMap,
            //   createNewPolygon,
            //   updateAutoSave,
            //   resetAllOnceChanged,
            //   getCurrentPoiSetting,
            //   setDrawnFeaturesSupport,
            //   setUndoHistory,
            //   setRedoHistory,
            //   disableUserActions,
            //   markerRef,
            // });
          }
        }
      });

      if (poiSetting.poiCallOut === "callout") {
        if (allCallOutMarker.current) {
          let index = markerRef.current.indexOf(allCallOutMarker.current);
          if (index > -1) {
            markerRef.current[index] = allCallOutMarker.current;
          }
        }
      }
      if (imageLayerToBeAdded) {
        this.AddPoiImageLayer({
          map,
          imageLayerList: imageLayerToBeAdded,
          POICategoryList: previousValue,
        });
      }
      // dispatch(triggerSaveQuickGuide(true));
      return previousValue;
    });
  };

  static AddPoiImageLayer = ({
    map,
    imageLayerList,
    POICategoryList,
    reset,
  }) => {
    if (map) {
      const geojsonData = {
        type: "FeatureCollection",
        features: imageLayerList,
      };
      const currentLayer = map.getSource("POIImageSource");
      if (currentLayer) {
        if (reset) {
          geojsonData.features = [];
        } else {
          const getBound = map.getBounds();
          const selectedPoiRetailerId = Object.keys(
            POICategoryList.selectedPOIRetailerNameList
          );
          if (
            currentLayer._data.features &&
            Array.isArray(currentLayer._data.features)
          ) {
            const featureToBeAdded = currentLayer._data.features.filter(
              (feature) => {
                const featureChecked = geojsonData.features.find(
                  (featurePoi) => featurePoi.id === feature.id
                );
                if (
                  ((feature.properties &&
                    feature.properties.retailer_id &&
                    selectedPoiRetailerId.includes(
                      feature.properties.retailer_id
                    ) &&
                    getBound.contains([
                      feature.properties.longitude,
                      feature.properties.latitude,
                    ])) ||
                    POICategoryList.selectedAsLayer.includes(
                      feature.properties.retailer_id
                    )) &&
                  !featureChecked
                ) {
                  return true;
                } else {
                  return false;
                }
              }
            );
            geojsonData.features = [
              ...geojsonData.features,
              ...featureToBeAdded,
            ];
          }
        }
        geojsonData.features = [...new Set(geojsonData.features)];
        map.getSource("POIImageSource").setData(geojsonData);
      } else {
        // Source does not exist, add it
        map.addSource("POIImageSource", {
          type: "geojson",
          data: geojsonData,
        });
      }
      if (map.getLayer("POIImageLayer")) {
        return;
      } else {
        map.addLayer({
          id: "POIImageLayer",
          type: "circle",
          source: "POIImageSource",
          paint: {
            "circle-radius": [
              "case",
              ["has", "circle_radius"],
              ["get", "circle_radius"],
              10,
            ],
            "circle-color": [
              "case",
              ["has", "circle_color"],
              ["get", "circle_color"],
              "#ffffff",
            ],
          },
        });
      }
    }
  };

  static GetClusterImageList = ({
    inputMarkerId,
    logoDefaultStyle,
    poiSetting,
    logo,
  }) => {
    const poiImageId = inputMarkerId.startsWith("poiImage^");
    // const divSubContainerElement = document.createElement("div");
    // divSubContainerElement.id = inputMarkerId;
    // Sub div element
    const divSubElement = document.createElement("div");
    divSubElement.classList.add("logo-grid-item");
    // divSubElement.style.width = "100px";
    // divSubElement.style.height = "100px";
    divSubElement.id = inputMarkerId;

    // Create the Image element
    const logoImg = document.createElement("img");
    logoImg.className = "marker-image";
    logoImg.src = logo;
    logoImg.alt = "logo";
    logoImg.id = inputMarkerId;
    logoImg.style.backgroundColor = poiImageId
      ? poiSetting.poiBackgroundColor
      : logoDefaultStyle.logoBackgroundColor;
    logoImg.style.objectFit = "contain";
    // Adding box style
    const haloEffectX = poiImageId
      ? poiSetting.poiHaloEffect_x
      : logoDefaultStyle.logoHaloEffect_x;
    const haloEffectY = poiImageId
      ? poiSetting.poiHaloEffect_y
      : logoDefaultStyle.logoHaloEffect_y;
    const haloEffectB = poiImageId
      ? poiSetting.poiHaloEffect_b
      : logoDefaultStyle.logoHaloEffect_b;
    const logoHaloEffect = poiImageId
      ? poiSetting.poiHaloEffect
      : logoDefaultStyle.logoHaloEffect;

    logoImg.style.boxShadow = `${haloEffectX}px ${haloEffectY}px ${haloEffectB}px ${logoHaloEffect}`;
    // if (poiImageId) {
    //   logoImg.dataset.width = poiSetting.poiWidthAndHeight;
    // } else {
    //   logoImg.dataset.width = "300px";
    // }
    const isBackgroundTransparent = poiImageId
      ? poiSetting.poiBackgroundTransparent
      : logoDefaultStyle.isBackgroundColorTransparent;

    if (!isBackgroundTransparent) {
      if ((poiImageId && poiSetting.poiHaloEffectTransparent) || !poiImageId) {
        logoImg.style.filter = `drop-shadow(${haloEffectX}px ${haloEffectY}px ${haloEffectB}px ${logoHaloEffect})`;
      }
      logoImg.style.boxShadow = "unset";
      logoImg.style.backgroundColor = "transparent";
    }

    // Adding box DataSet
    logoImg.dataset.backgroundColor = poiImageId
      ? poiSetting.poiBackgroundColor
      : logoDefaultStyle.logoBackgroundColor;
    logoImg.dataset.leaderLineColor = logoDefaultStyle.logoLeaderLineColor;
    logoImg.dataset.isBackgroundTransparent =
      logoDefaultStyle.isBackgroundColorTransparent ? "true" : "false";

    logoImg.dataset.leaderLineWidth = String(
      logoDefaultStyle.logoLeaderLineBorderWidth
    );
    logoImg.dataset.logoHaloEffect_x = poiImageId
      ? String(poiSetting.poiHaloEffect_x)
      : String(logoDefaultStyle.logoHaloEffect_x);
    logoImg.dataset.logoHaloEffect_y = poiImageId
      ? String(poiSetting.poiHaloEffect_y)
      : String(logoDefaultStyle.logoHaloEffect_y);
    logoImg.dataset.logoHaloEffect_b = poiImageId
      ? String(poiSetting.poiHaloEffect_b)
      : String(logoDefaultStyle.logoHaloEffect_b);
    logoImg.dataset.logoHaloEffect = poiImageId
      ? poiSetting.poiHaloEffect
      : logoDefaultStyle.logoHaloEffect;
    logoImg.dataset.connectedLeaderLineWidth =
      logoDefaultStyle.logoLeaderLineColor;
    logoImg.dataset.connectedLeaderLineColor = String(
      logoDefaultStyle.logoLeaderLineBorderWidth
    );
    logoImg.dataset.leaderLineEnabled = "true";
    logoImg.dataset.lineConnected = inputMarkerId;

    // Appending child to main div
    divSubElement.appendChild(logoImg);
    return divSubElement;
  };

  static RemovePoiImageOutOfBound = ({
    POICategoryList,
    map,
    mapDraw,
    mapboxgl,
    setPOICategoryList,
    lastClickButton,
    logoDefaultStyle,
    defaultLogoValue,
    poiSetting,
    setSelectedLogo,
    setMapToolBarOptionFlags,
    setResetMap,
    createNewPolygon,
    updateAutoSave,
    resetAllOnceChanged,
    currentMode,
    polygonDefaultStyle,
    getCurrentPoiSetting,
    setDrawnFeaturesSupport,
    setUndoHistory,
    setRedoHistory,
    markerRef,
  }) => {
    if (map) {
      const selectedPoiRetailerId = Object.keys(
        POICategoryList.selectedPOIRetailerNameList
      );
      const selectedPoiRetailerIdAsLayer = POICategoryList.selectedAsLayer;
      //const getBound = map.getBounds();
      setSelectedLogo(null);
      const changedMarkers = markerRef.current.filter((marker) => {
        let returnCondition = true;
        const markerId = marker.id.split("^");
        if (
          marker.id.startsWith("poiImage^") &&
          markerId &&
          markerId.length > 3 &&
          markerId[3]
        ) {
          if (
            !selectedPoiRetailerId.includes(markerId[3]) ||
            selectedPoiRetailerIdAsLayer.includes(markerId[3])
          ) {
            const markerElement = marker.marker.getElement();
            const image = markerElement.querySelector("img");
            marker.marker.remove();
            const vertexPoint = map.getLayer(marker.id + "-end-point");
            if (vertexPoint) {
              map.removeLayer(marker.id + "-end-point");
              map.removeSource(marker.id + "-end-point");
            }
            mapDraw = mapDraw.current || mapDraw;
            mapDraw.delete(image.dataset.lineConnected);

            this.RemoveElementFromObjectArray({
              keyToRemove: markerId[3],
              valueToRemove: image.id,
              setPOICategoryList,
            });
            setUndoHistory((previousState) =>
              previousState.filter((data) => data.id !== marker.id)
            );
            setRedoHistory([]);
            returnCondition = false;
            if (marker.idList) {
              marker.idList.forEach((subLogoElement) => {
                const subMarkerId = subLogoElement.split("^");
                if (
                  (selectedPoiRetailerId.includes(subMarkerId[3]) &&
                    !selectedPoiRetailerIdAsLayer.includes(subMarkerId[3])) ||
                  subLogoElement.startsWith("imageArea^")
                ) {
                  // CustomLogoClass.AddLogoToMap({
                  //   mapboxgl,
                  //   map,
                  //   mapDraw,
                  //   coordinates: {
                  //     lat: parseFloat(subMarkerId[2]),
                  //     lng: parseFloat(subMarkerId[1]),
                  //   },
                  //   logo: subLogoElement.startsWith("poiImage^")
                  //     ? this.GetPoiImageUrl(subMarkerId[3])
                  //     : subMarkerId[3],
                  //   lastClickButton,
                  //   logoDefaultStyle,
                  //   defaultLogoValue,
                  //   setSelectedLogo,
                  //   setMapToolBarOptionFlags,
                  //   setResetMap,
                  //   createNewPolygon,
                  //   updateAutoSave,
                  //   resetAllOnceChanged,
                  //   poiImageId: subLogoElement.startsWith("poiImage^")
                  //     ? subLogoElement
                  //     : null,
                  //   currentMode,
                  //   polygonDefaultStyle,
                  //   getCurrentPoiSetting,
                  //   setDrawnFeaturesSupport,
                  //   setUndoHistory,
                  //   setRedoHistory,
                  //   poiWidth: this.POIImageWidth,
                  //   markerRef,
                  // });
                } else {
                  setUndoHistory((previousState) =>
                    previousState.filter((data) => data.id !== subLogoElement)
                  );
                  setRedoHistory([]);
                }
              });
            }
            return returnCondition;
          }
          if (marker.idList) {
            const markerElement = marker.marker.getElement();

            const subDivElement = markerElement.querySelector("div");

            const logoElementToBeAppend = subDivElement.querySelectorAll("div");
            const changedMapList = marker.idList.filter((subLogoElement) => {
              const subMarkerId = subLogoElement.split("^");
              if (
                (!selectedPoiRetailerId.includes(subMarkerId[3]) ||
                  selectedPoiRetailerIdAsLayer.includes(subMarkerId[3])) &&
                !subLogoElement.startsWith("imageArea^")
              ) {
                logoElementToBeAppend.forEach((iteratorElement) => {
                  if (iteratorElement.id === subLogoElement) {
                    iteratorElement.remove();
                  }
                });
                return false;
              } else {
                setUndoHistory((previousState) =>
                  previousState.filter((data) => data.id !== subLogoElement)
                );
                setRedoHistory([]);
              }
              return true;
            });
            // Remove all event listener for single clustered logo
            if (changedMapList && changedMapList.length === 1) {
              const clonedMarkerDiv = marker.marker.getElement();
              const clonedSubDivElement = clonedMarkerDiv
                .querySelector("div")
                .cloneNode(true);
              const clonedSubDivSpan = clonedMarkerDiv.querySelector("span");
              if (clonedSubDivSpan) {
                clonedSubDivSpan.remove();
              }
              const SubDivElement = clonedMarkerDiv.querySelector("div");
              SubDivElement.remove();

              const clonedSubDivContainer =
                clonedSubDivElement.querySelector("div");
              const logoImg = clonedSubDivElement.querySelector("img");

              clonedMarkerDiv.dataset.cluster = "false";
              clonedMarkerDiv.style.width = poiSetting.poiWidthAndHeight;
              clonedMarkerDiv.style.height = "auto";
              clonedSubDivElement.className = "";
              clonedSubDivElement.style.width = "unset";
              clonedSubDivElement.style.height = "unset";
              clonedSubDivContainer.style.width = "100%";
              clonedSubDivContainer.style.height = "100%";
              clonedMarkerDiv.appendChild(clonedSubDivElement);

              logoImg.addEventListener("contextmenu", (event) => {
                //if (disableUserActions()) return;
                event.preventDefault();
                lastClickButton.current = 0;
                resetAllOnceChanged();
                CustomLogoClass.GetLogoStyleWithLeaderLine({
                  mapDraw,
                  imageMarker: marker.marker,
                  logoElement: logoImg,
                  logoDefaultStyle,
                  setSelectedLogo,
                });
              });

              CustomLogoClass.AddLogoEventListener({
                map,
                mapDraw,
                mapboxgl,
                imageMarker: marker.marker,
                logoElement: logoImg,
                connectedLeaderLineId: logoImg.id,
                logoDefaultStyle,
                lastClickButton,
                defaultLogoValue,
                poiSetting,
                setSelectedLogo,
                setMapToolBarOptionFlags,
                updateAutoSave,
                setResetMap,
                createNewPolygon,
                resetAllOnceChanged,
                currentMode,
                polygonDefaultStyle,
                getCurrentPoiSetting,
                setDrawnFeaturesSupport,
                setUndoHistory,
                setRedoHistory,
                markerRef,
              });
            }
            marker.idList = changedMapList;
            return marker;
          }
          return returnCondition;
        } else if (
          marker.id.startsWith("imageArea^") &&
          markerId &&
          markerId.length > 3 &&
          markerId[3] &&
          marker.idList
        ) {
          const markerElement = marker.marker.getElement();

          const subDivElement = markerElement.querySelector("div");

          const logoElementToBeAppend = subDivElement.querySelectorAll("div");
          const changedMapList = marker.idList.filter((subLogoElement) => {
            const subMarkerId = subLogoElement.split("^");
            if (
              (!selectedPoiRetailerId.includes(subMarkerId[3]) ||
                selectedPoiRetailerIdAsLayer.includes(subMarkerId[3])) &&
              !subLogoElement.startsWith("imageArea^")
            ) {
              logoElementToBeAppend.forEach((iteratorElement) => {
                if (iteratorElement.id === subLogoElement) {
                  iteratorElement.remove();
                }
              });
              return false;
            }
            return true;
          });
          // Remove all event listener for single clustered logo
          if (changedMapList && changedMapList.length === 1) {
            const clonedMarkerDiv = marker.marker.getElement();
            const clonedSubDivElement = clonedMarkerDiv
              .querySelector("div")
              .cloneNode(true);
            const clonedSubDivSpan = clonedMarkerDiv.querySelector("span");
            if (clonedSubDivSpan) {
              clonedSubDivSpan.remove();
            }
            const SubDivElement = clonedMarkerDiv.querySelector("div");
            SubDivElement.remove();

            const clonedSubDivContainer =
              clonedSubDivElement.querySelector("div");
            const logoImg = clonedSubDivElement.querySelector("img");

            clonedMarkerDiv.dataset.cluster = "false";
            clonedMarkerDiv.style.width = poiSetting.poiWidthAndHeight;
            clonedMarkerDiv.style.height = "auto";
            clonedSubDivElement.className = "";
            clonedSubDivElement.style.width = "unset";
            clonedSubDivElement.style.height = "unset";
            clonedSubDivContainer.style.width = "100%";
            clonedSubDivContainer.style.height = "100%";
            clonedMarkerDiv.appendChild(clonedSubDivElement);

            logoImg.addEventListener("contextmenu", (event) => {
              //if (disableUserActions()) return;
              event.preventDefault();
              lastClickButton.current = 0;
              resetAllOnceChanged();
              CustomLogoClass.GetLogoStyleWithLeaderLine({
                mapDraw,
                imageMarker: marker.marker,
                logoElement: logoImg,
                logoDefaultStyle,
                setSelectedLogo,
              });
            });

            CustomLogoClass.AddLogoEventListener({
              map,
              mapDraw,
              mapboxgl,
              imageMarker: marker.marker,
              logoElement: logoImg,
              connectedLeaderLineId: logoImg.id,
              logoDefaultStyle,
              lastClickButton,
              defaultLogoValue,
              poiSetting,
              setSelectedLogo,
              setMapToolBarOptionFlags,
              updateAutoSave,
              setResetMap,
              createNewPolygon,
              resetAllOnceChanged,
              currentMode,
              polygonDefaultStyle,
              getCurrentPoiSetting,
              setDrawnFeaturesSupport,
              setUndoHistory,
              setRedoHistory,
              markerRef,
            });
          }
          marker.idList = changedMapList;
          return marker;
        }
        return true;
      });
      markerRef.current = changedMarkers;
    }
  };

  static ClusterImageInsideBound = async ({
    coordinates,
    map,
    mapDraw,
    mapboxgl,
    logoDefaultStyle,
    disableUserActions,
    lastClickButton,
    defaultLogoValue,
    poiSetting,
    setSelectedLogo,
    setMapToolBarOptionFlags,
    updateAutoSave,
    setResetMap,
    createNewPolygon,
    resetAllOnceChanged,
    currentMode,
    polygonDefaultStyle,
    getCurrentPoiSetting,
    setDrawnFeaturesSupport,
    setUndoHistory,
    setRedoHistory,
    markerRef,
  }) => {
    const polygon = turf.polygon(coordinates);
    const toBeClustered = [];
    let toBeClusteredFirstMarker = null;
    const changedMarkers = markerRef.current.filter((element) => {
      if (
        element.id.startsWith("poiImage^") ||
        element.id.startsWith("imageArea^")
      ) {
        const currentImageId = element.id.split("^");
        const markerLocation = element.marker.getLngLat();
        const point = turf.point([markerLocation.lng, markerLocation.lat]);
        const isInside = turf.booleanPointInPolygon(point, polygon);
        if (isInside) {
          if (toBeClusteredFirstMarker) {
            if (
              !element.idList ||
              (element.idList && element.idList.length === 0)
            ) {
              const toBeClusteredLocal = {
                id: element.id,
                src: currentImageId[3],
              };
              if (element.id.startsWith("imageArea^")) {
                toBeClusteredLocal.src = currentImageId[3];
              } else if (element.id.startsWith("poiImage^")) {
                toBeClusteredLocal.src = this.GetPoiImageUrl(currentImageId[3]);
              }
              if (!toBeClustered.includes(toBeClusteredLocal)) {
                toBeClustered.push(toBeClusteredLocal);
              }
              toBeClusteredFirstMarker.idList?.push(element.id);
            } else {
              element.idList.forEach((subElement) => {
                const subImageId = subElement.split("^");
                const toBeClusteredLocal = {
                  id: subElement,
                  src: currentImageId[3],
                };
                if (subElement.startsWith("imageArea^")) {
                  toBeClusteredLocal.src = subImageId[3];
                } else if (subElement.startsWith("poiImage^")) {
                  toBeClusteredLocal.src = this.GetPoiImageUrl(subImageId[3]);
                }
                if (!toBeClustered.includes(toBeClusteredLocal)) {
                  toBeClustered.push(toBeClusteredLocal);
                }
                if (
                  toBeClusteredFirstMarker &&
                  toBeClusteredFirstMarker.idList
                ) {
                  toBeClusteredFirstMarker.idList.push(subElement);
                }
              });
            }
            if (toBeClusteredFirstMarker.id !== element.id) {
              element.marker.remove();
              mapDraw.current.delete(element.id);
            }
            const vertexPoint = map.getLayer(element.id + "-end-point");
            if (vertexPoint) {
              map.removeLayer(element.id + "-end-point");
              map.removeSource(element.id + "-end-point");
            }
            return false;
          } else {
            toBeClusteredFirstMarker = element;
            toBeClusteredFirstMarker.idList = [element.id];
            return true;
          }
        }
      }
      return true;
    });
    if (toBeClusteredFirstMarker && toBeClustered.length > 0) {
      const currentMarkerElement = toBeClusteredFirstMarker.marker.getElement();
      const currentMarkerElementContainer =
        currentMarkerElement.querySelector("div");
      const currentMarkerElementSubElement =
        currentMarkerElementContainer.querySelector("div");
      toBeClusteredFirstMarker.idList = toBeClustered.map((list) => list.id);
      toBeClusteredFirstMarker.idList.push(toBeClusteredFirstMarker.id);
      const poiSettingLive = getCurrentPoiSetting();
      toBeClustered.forEach((element, i) => {
        const subElement = this.GetClusterImageList({
          inputMarkerId: element.id,
          logoDefaultStyle,
          poiSetting: poiSettingLive,
          logo: element.src,
        });
        // CustomLogoClass.AddClusterLogoEventListener({
        //   currenMarker: toBeClusteredFirstMarker.marker,
        //   subElement,
        //   map,
        //   mapDraw,
        //   mapboxgl,
        //   logoDefaultStyle,
        //   lastClickButton,
        //   defaultLogoValue,
        //   poiSetting,
        //   setSelectedLogo,
        //   setMapToolBarOptionFlags,
        //   updateAutoSave,
        //   setResetMap,
        //   createNewPolygon,
        //   resetAllOnceChanged,
        //   currentMode,
        //   polygonDefaultStyle,
        //   getCurrentPoiSetting,
        //   setDrawnFeaturesSupport,
        //   setUndoHistory,
        //   setRedoHistory,
        //   markerRef,
        //   disableUserActions,
        // });
        let gridTemplateValue = [];
        if (i === 1 || i === 2) {
          for (let j = 0; j <= i; j++) {
            gridTemplateValue.push("auto");
          }
          currentMarkerElementContainer.style.gridTemplateColumns =
            gridTemplateValue.join(" ");
        }
        currentMarkerElementContainer.appendChild(subElement);
      });
      // CustomLogoClass.AddClusterLogoEventListener({
      //   currenMarker: toBeClusteredFirstMarker.marker,
      //   subElement: currentMarkerElementSubElement,
      //   map,
      //   mapDraw,
      //   mapboxgl,
      //   logoDefaultStyle,
      //   lastClickButton,
      //   defaultLogoValue,
      //   poiSetting,
      //   setSelectedLogo,
      //   setMapToolBarOptionFlags,
      //   updateAutoSave,
      //   setResetMap,
      //   createNewPolygon,
      //   resetAllOnceChanged,
      //   currentMode,
      //   polygonDefaultStyle,
      //   getCurrentPoiSetting,
      //   setDrawnFeaturesSupport,
      //   setUndoHistory,
      //   setRedoHistory,
      //   markerRef,
      //   disableUserActions,
      // });
      currentMarkerElement.style.width = "auto";
      currentMarkerElement.style.height = "auto";
      // currentMarkerElementSubElement.style.height = "100px";
      // currentMarkerElementSubElement.style.width = "100px";
      const checkClusterHasClusterControlTag =
        currentMarkerElement.querySelector("#move-cluster-leader-line");
      if (!checkClusterHasClusterControlTag) {
        const headerIconsDiv = this.GetClusterHeaderIcons();
        currentMarkerElement.appendChild(headerIconsDiv);
        const mapClusterInterActionFunction =
          CustomLogoClass.GetLogoInteractionButtons(true);
        headerIconsDiv.append(mapClusterInterActionFunction.move);
        headerIconsDiv.append(mapClusterInterActionFunction.remove);
        mapClusterInterActionFunction.remove.addEventListener(
          "mousedown",
          function () {
            CustomLogoClass.ClusterOutAllImagesInside({
              marker: toBeClusteredFirstMarker.marker,
              map,
              mapDraw,
              mapboxgl,
              logoDefaultStyle,
              lastClickButton,
              defaultLogoValue,
              poiSetting,
              setSelectedLogo,
              setMapToolBarOptionFlags,
              updateAutoSave,
              setResetMap,
              createNewPolygon,
              resetAllOnceChanged,
              currentMode,
              polygonDefaultStyle,
              getCurrentPoiSetting,
              setDrawnFeaturesSupport,
              setUndoHistory,
              setRedoHistory,
              markerRef,
            });
          }
        );
      }
      currentMarkerElementContainer.classList.add("logo-grid-container");
      currentMarkerElementContainer.classList.add("scrollbar-lg");
      currentMarkerElement.dataset.cluster = "true";
      let index = changedMarkers.indexOf(toBeClusteredFirstMarker);
      if (index > -1) {
        changedMarkers[index] = toBeClusteredFirstMarker;
      }
    }
    markerRef.current = changedMarkers;
  };
}
